// The inbox (A5U8, A13U4), owned by hand: the notifications across organizations; the badge lives in the navigation.
// `?open=<id>` is the item beside the list (D194 (8)), `?org=<id>` the filter and `?back=<slug>` the context an item of
// another organization switched away from (A18U2), so all three survive a reload.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { NotificationsInbox } from '../../features/notifications/NotificationsInbox'
import { notificationsQuery } from '../../features/notifications/queries'
import { meQuery } from '../../shared/org/me'
import { text } from '../../shared/routing/search'
import { Part } from '../../shared/shell/StatePart'

type Search = { open?: string; org?: string; back?: string }

export const Route = createFileRoute('/inbox/')({
  staticData: { screenId: 'NotificationsInboxScreen', access: 'signed in', ownHeader: true },
  validateSearch: (search: Record<string, unknown>): Search => ({
    open: text(search.open),
    org: text(search.org),
    back: text(search.back),
  }),
  // The account too, so the navigation's badge knows a person is signed in (UnreadBadge waits for it).
  loader: ({ context: { queryClient } }) =>
    Promise.all([queryClient.ensureInfiniteQueryData(notificationsQuery()), queryClient.ensureQueryData(meQuery())]),
  component: NotificationsInboxScreen,
})

function NotificationsInboxScreen() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const setSearch = (next: Search, replace = false) =>
    void navigate({ search: (prev) => ({ ...prev, ...next }), replace })
  return (
    <main data-testid={ids.notificationsInbox.root}>
      <Part testId={ids.notificationsInbox.skeleton}>
        <NotificationsInbox
          openId={search.open}
          org={search.org}
          back={search.back}
          onOpenId={(open, switched) => setSearch(switched ? { open, back: switched.back } : { open })}
          onOrg={(org) => setSearch({ org, open: undefined }, true)}
          onBack={() => setSearch({ open: undefined, back: undefined })}
        />
      </Part>
    </main>
  )
}
